import React, { FC, ReactNode } from 'react';
import { Box } from '@ch/common/components/box';
import { Heading } from '@ch/common/components/heading';
import { Text } from '@ch/common/components/text';
import { useData } from '../use-data';

const QuizHeading: FC<{ children: string | ReactNode; customLayout: boolean }> = ({ children, customLayout }) => {
  const {
    data: {
      mandatory: { mandatoryAll },
    },
  } = useData();
  return (
    <Box $m={[0, 0, 25]} $p={[20, 0, 0]}>
      <Heading $m={[0, 0, 8]} $fontFamily="aeonikLight">
        {children}
      </Heading>
      {!customLayout && (
        <Box $bgColor="grayLighter" $display="inline-block" $p={[0, 5]} $radius={4}>
          <Text $m={[0]} $size="sm" dangerouslySetInnerHTML={{ __html: mandatoryAll }} />
        </Box>
      )}
    </Box>
  );
};

export default QuizHeading;
